import Component from '../core/Component'
import $ from 'jquery'
import { throttle } from 'underscore'

export default class InViewport extends Component {

    constructor($element) {
        super($element)
        this.offset = 0
        this.displayed = false
        this.visible = false
        this.$components = this.$element.find('[data-component]')

        if (this.$element.data('offset') != null) {
            this.offset = parseInt(this.$element.data('offset'))
        }
    }

    prepare() {
        $(window).on('scroll', throttle(::this.checkAndApply)).on('load', throttle(::this.checkAndApply))
    }

    checkAndApply () {
        var inViewport = this.elementInViewport()
        if (inViewport != this.visible) {
            if (inViewport) {
                // is visible
                this.$element.removeClass('not-visible')
                this.$element.addClass('is-visible')
                this.$components.each(function () {
                    $(this).trigger('isVisible')
                })

                if (!this.displayed) {
                    // first visible
                    this.$element.addClass('has-displayed')
                    this.$components.each(function () {
                        $(this).trigger('hasDisplayed')
                    })
                    this.displayed = true
                }
            } else {
                // is not visible
                this.$element.removeClass('is-visible')
                this.$element.addClass('not-visible')
                this.$components.each(function () {
                    $(this).trigger('notVisible')
                })
            }
        }
        
        this.visible = inViewport
    }

    elementInViewport() {
        var el = this.element

        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) - this.offset &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset - this.offset &&
            (left + width) > window.pageXOffset
        )
    }
}


// WEBPACK FOOTER //
// ./components/InViewport.js